import { render, staticRenderFns } from "./LeaveBalance.vue?vue&type=template&id=1d48f1c4"
import script from "./LeaveBalance.vue?vue&type=script&lang=js"
export * from "./LeaveBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports